import { get } from '@/untils/axios.js'

// 操作日志
export const actionlog = params => get('actionlog', params)

// 用户信息
export const userinfo = params => get('manager/getinfo', params)